var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep6To2Mobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 313,
    viewBox: "0 0 80 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.646462 3.64645C0.451202 3.84171 0.451202 4.1583 0.646461 4.35356L3.82845 7.53554C4.0237 7.7308 4.34029 7.7308 4.53555 7.53554C4.73081 7.34028 4.73081 7.02369 4.53555 6.82843L1.70712 4.00001L4.53555 1.17158C4.73081 0.976316 4.73081 0.659734 4.53555 0.464472C4.34029 0.269209 4.0237 0.269209 3.82845 0.464472L0.646462 3.64645ZM79.5 313L79.5 24L78.5 24L78.5 313L79.5 313ZM59 3.5L1.00002 3.50001L1.00002 4.50001L59 4.5L59 3.5ZM79.5 24C79.5 12.6782 70.3218 3.5 59 3.5L59 4.5C69.7696 4.5 78.5 13.2304 78.5 24L79.5 24Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep6To2Mobile);
export default __webpack_public_path__ + "static/media/step_6_to_2_mobile.7ceed19cdc6a1d9cbba25339ffb369fb.svg";
export { ForwardRef as ReactComponent };